import FJActionConstant from "../../constant/FJActionConstant";
import FJCoreUtil from "../../core/util/FJCoreUtil";
import FJViewConstant from "../../constant/FJViewConstant";

let FJResourceAction = (function () {
  return {

    /**
     * @description 切换菜单栏
     * @param type
     * @param direction
     * @param expand
     * @returns {{showType: *, type: string}}
     */
    setShowTypeAction: function (type, direction, expand) {
      return (dispatch, getState) => {
        if (getState().resource.showType !== type) {
          dispatch({
            type: FJActionConstant.UPDATE_SHOW_TYPE,
            showType: type,
            direction,
          });
        }

        if (expand) {
          dispatch(this.setResourceExpandAction(true));
        }
      };
    },

    /**
     * @description 设置最后一个的资源类型
     * @param type
     * @return {{lastType, type: string}}
     */
    setLastTypeAction: function (type) {
      return {
        type: FJActionConstant.UPDATE_LAST_TYPE,
        lastType: type,
      }
    },

    /**
     * @description 切换资源面板展开
     */
    toggleResourceExpandAction: function () {
      return (dispatch, getState) => {
        const toggle = !getState().resource.isResourceExpand;
        FJCoreUtil.triggerBodyMousedown();
        if (!toggle) {
          dispatch(this.resetResourcePanelByToolbar());
        }
        dispatch(this.setResourceExpandAction(toggle));
      }
    },

    resetResourcePanelByToolbar: function () {
      return (dispatch, getState) => {
        const {showType, lastType} = getState().resource;
        const {
          RESOURCES_TRANSITION,
          RESOURCES_ANIMATION_INTRO,
          RESOURCES_ANIMATION_OUTRO,
          RESOURCES_FILTER,
          RESOURCES_ADJUST,
          RESOURCES_PHOTO_TRANSITION,
        } = FJViewConstant;

        if (showType !== lastType
          && [
            RESOURCES_TRANSITION,
            RESOURCES_ANIMATION_INTRO,
            RESOURCES_ANIMATION_OUTRO,
            RESOURCES_FILTER,
            RESOURCES_ADJUST,
            RESOURCES_PHOTO_TRANSITION,
          ].includes(showType)) {
          dispatch(FJResourceAction.setShowTypeAction(lastType));
        }
      }
    },

    /**
     * @description 设置资源面板是否展开
     * @param isResourceExpand
     * @return {{isResourceExpand, type: string}}
     */
    setResourceExpandAction: function (isResourceExpand) {
      return {
        type: FJActionConstant.TOGGLE_RESOURCE_EXPAND,
        isResourceExpand,
      }
    },
  }
})();

export default FJResourceAction;
